import { render, staticRenderFns } from "./InputTextDialog.vue?vue&type=template&id=a9989976"
import script from "./InputTextDialog.vue?vue&type=script&lang=js"
export * from "./InputTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports